
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'L_T4_Child',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/L_T4_Child.vue